<template>
  <v-card class="elevation-12">
    <UsersDataTable
        :loading="loading"
        :users="users"
        :total="total"
        @update="onUpdate"
    />
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import UserService from "@/services/user.service";
import _ from "underscore";
import Mappers from "@/mappers";
import UsersDataTable from "../../components/user/UsersDataTable";

export default {
  name: "UsersPage",
  components: {
    UsersDataTable,
  },
  data() {
    return {
      users: [],
      total: 0,
      loading: false,
    }
  },
  methods: {
    reloadUsers(options, filters) {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {inn, user, username} = filters;
      const {page, itemsPerPage} = options;

      const skip = (page - 1) * itemsPerPage;

      UserService.getUsers({
        skip: skip,
        limit: itemsPerPage,
        inn: inn,
        user: user,
        username: username
      })
          .then(response => {
            this.users = _.map(response.data.Records, o => {
              return Mappers.mapUser(o)
            })

            this.total = response.data.Total
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadUsers(options, filters)
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('usersPage.pageTitle'))
  }
}
</script>